var map = {
	".": "bXuT",
	"./": "bXuT",
	"./email": "OuLO",
	"./email-otp": "D8lJ",
	"./email-otp.js": "D8lJ",
	"./email.js": "OuLO",
	"./index": "bXuT",
	"./index.js": "bXuT",
	"./otp-form": "11FI",
	"./otp-form.js": "11FI",
	"./phone": "eL0u",
	"./phone-otp": "ojIE",
	"./phone-otp.js": "ojIE",
	"./phone.js": "eL0u"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eeLr";